import React from "react";
import { FooterWrapper } from "./AdminFooterOrganismStyles";

export interface AdminFooterProps {}

const AdminFooter: React.FC<AdminFooterProps> = () => {
  const currentYear = new Date().getFullYear()
  return (
    <FooterWrapper>&#169; {currentYear} RxMax and Inventory Services LLC.</FooterWrapper>
  );
};

export default AdminFooter;
